import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: "/",
    name: "index",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/download",
    name: "download",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/download.vue"),
    meta: {
      title: "下载",
    },
  },
  {
    path: "/success",
    name: "success",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/success.vue"),
    meta: {
      title: "人脸识别成功",
    },
  },
  {
    path: "/failure",
    name: "failure",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/failure.vue"),
    meta: {
      title: "人脸识别失败",
    },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
